import { ROLES } from '@/constants/roles';
import { DRAWER_TYPES } from '@/constants/drawer';

const TEAM_VIEW_CHILDREN = [
  {
    path: 'members',
    component: () => import('./views/my-teams-view/children/members-list.vue'),
    meta: {
      subdrawer: DRAWER_TYPES.portal,
    },
  },
  {
    path: 'invite',
    component: () => import('./views/my-teams-view/children/members-invite.vue'),
    meta: {
      subdrawer: DRAWER_TYPES.portal,
    },
  },
  {
    path: 'chat',
    component: () => import('./views/my-teams-view/children/members-chat.vue'),
    meta: {
      subdrawer: DRAWER_TYPES.portal,
    },
  },
];

export const teams = {
  path: '/teams',
  component: () => import('./views/EventTeams/index.vue'),

  meta: {
    title: 'Команды',
    icon: '$iuser-team',
    accessList: [ROLES.certificate, ROLES.member, ROLES.trainer],

    children: [
      {
        text: 'Команды мероприятий',
        to: '/teams',
        icon: 'mdi-calendar-account-outline',
        visibleFor: [ROLES.certificate, ROLES.member],
      },
      {
        text: 'Команды друзей',
        to: '/my-teams',
        icon: 'mdi-account-group-outline',
        visibleFor: [ROLES.certificate, ROLES.member],
      },
      {
        text: 'История команд',
        to: '/team-history',
        icon: 'mdi-history',
        visibleFor: [ROLES.certificate, ROLES.member],
      },
    ],
  },
};

export const teamFriends = {
  path: '/team-friends',
  name: 'team-friends-list',
  component: () => import('./views/FriendTeams/index.vue'),
  meta: {
    title: 'Мои команды',
    accessList: [ROLES.certificate, ROLES.member, ROLES.trainer],
    instruction: {
      id: 41,
      name: 'Создание команды',
    },
  },
};

export const myTeamsEventsRequests = {
  path: '/my-teams-events',
  name: 'my-events-teams-requests-list',
  component: () => import('./views/my-teams-events.vue'),

  meta: {
    title: 'Мои мероприятия',
    icon: 'mdi-calendar-account-outline',
    accessList: [ROLES.trainer],
  },
};

export const myTeamsList = {
  path: '/my-teams',
  name: 'my-teams-list',
  component: () => import('./views/my-teams.vue'),

  meta: {
    title: 'Мои команды',
    icon: '$iuser-team',
    accessList: [ROLES.trainer],
  },
};

export const myTeamsView = {
  path: '/my-teams/:type/:id',
  name: 'my-teams-view',
  component: () => import('./views/my-teams-view/index.vue'),
  children: TEAM_VIEW_CHILDREN,

  meta: {
    title: 'Команда',
    accessList: [ROLES.trainer, ROLES.member, ROLES.certificate],
  },
};

export const myTeamsJoin = {
  path: '/team-join/:type/:id/hash/:hash',
  name: 'team-join',
  component: () => import('./views/my-teams-join.vue'),
  meta: {
    title: 'Вступить в команду',
  },
};

export const TeamEventRequest = {
  path: '/event/team-register/:id',
  component: () => import('./views/EventRegister/index.vue'),
  meta: {
    title: 'Запись на мероприятие',
    accessList: [ROLES.trainer],
  },
  children: [
    {
      path: '/',
      name: 'event-team-register',
      component: () => import('./views/EventRegister/child-main.vue'),
      meta: {
        accessList: [ROLES.trainer],
      },
    },
    {
      path: ':requestId',
      name: 'event-team-register-request',
      component: () => import('./views/EventRegister/child-request.vue'),
      meta: {
        accessList: [ROLES.trainer],
      },
    },
    {
      path: ':requestId/status',
      name: 'event-team-register-status',
      component: () => import('./views/EventRegister/child-status.vue'),
      meta: {
        accessList: [ROLES.trainer],
      },
    },
  ],
};

const routes = [
  teams,
  teamFriends,

  // Remaked teams
  myTeamsList,
  myTeamsEventsRequests,
  myTeamsView,
  myTeamsJoin,
  {
    path: '/team-friends/:id',
    name: 'team-friends-view',
    component: () => import('./views/FriendTeam/index.vue'),
    meta: {
      accessList: [ROLES.certificate, ROLES.member, ROLES.trainer],
      layout: 'empty',
    },
  },
  {
    path: '/teams/event/:id/stages',
    component: () => import('./views/EventStages/index.vue'),
    meta: {
      accessList: [ROLES.certificate, ROLES.member],
      subdrawer: DRAWER_TYPES.portal,
    },
  },
  {
    path: '/team-history',
    component: () => import('./views/TeamHistory/index.vue'),
    meta: {
      accessList: [ROLES.certificate, ROLES.member],
    },
  },
  {
    path: '/team/:id',
    name: 'team-view',
    component: () => import('./views/StageTeam/index.vue'),
    meta: {
      title: 'Страница команды',
      layout: 'empty',
      accessList: [ROLES.certificate, ROLES.member, ROLES.trainer],
    },
  },
  {
    path: '/team-view/:id',
    name: 'organization-team-view',
    component: () => import('./views/StageTeam/index.vue'),
    meta: {
      title: 'Страница команды',
      accessList: [ROLES.organization],
    },
  },
  {
    path: '/team/stage/view/:id',
    component: () => import('./views/TeamStage/index.vue'),
    meta: {
      accessList: [ROLES.certificate, ROLES.member],
      instruction: {
        id: 38,
        name: 'Команды',
      },
    },
  },
  TeamEventRequest,
];

export default routes;
